/**
 * Authority Inbox View
 * Dedicated route component for Authority inbox notifications
 */

import React from 'react';
import { InboxView } from './index';

const AuthorityInboxView = () => {
  // Sample data for inbox notifications
  const inboxNotifications = [
    { id: 1, type: 'confirmation', message: 'Confirmation letter received for complaint : GUH46899087', date: '3/4/2025', read: false },
    { id: 2, type: 'confirmation', message: 'Confirmation letter not received', date: '3/4/2025', read: false },
    { id: 3, type: 'complaint', message: 'This complain is the regarding the bad behaviour when i refused to give money ............', date: '3/4/2025', read: true },
    { id: 4, type: 'complaint', message: 'This complain is the regarding the bad behaviour when i refused to give money ............', date: '3/4/2025', read: true },
    { id: 5, type: 'complaint', message: 'This complain is the regarding the bad behaviour when i refused to give money ............', date: '3/4/2025', read: true },
    { id: 6, type: 'complaint', message: 'This complain is the regarding the bad behaviour when i refused to give money ............', date: '3/4/2025', read: true }
  ];

  return (
    <InboxView
      inboxNotifications={inboxNotifications}
    />
  );
};

export default AuthorityInboxView;
